import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-quote-layout',
	templateUrl: './quote-layout.component.html',
	styleUrls: ['./quote-layout.component.css']
})
export class QuoteLayoutComponent implements OnInit {

	screenWidth: number;
	isOpenMenu: boolean;

	constructor(private cdr: ChangeDetectorRef) {
		this.getScreenSize();
	}
	@HostListener('window:resize', ['$event'])
	getScreenSize(event?) {
	  setTimeout(() => {
		this.screenWidth = screen.width;
		this.cdr.detectChanges(); // Detect changes manually
	  });
	}

	onMenuChange(): void {
		this.isOpenMenu = !this.isOpenMenu;
	  }

	ngOnInit() {
	}

}
